import React from "react";
import { Icon, Phone } from "./icons";

const ITEMS = [
  {
    icon: "shield",
    title: "Sécurité avant tout",
    text: "Chauffeure professionnelle, trajets sécurisés, discrétion garantie.",
  },
  {
    icon: "comfort",
    title: "Confort premium",
    text: "Véhicule spacieux, climatisation, sièges confortables, chargeurs USB.",
  },
  {
    icon: "pin",
    title: "Longues distances",
    text: "Partout en France et en Europe.",
  },
  {
    icon: "calendar",
    title: "Réservation facile",
    text: "En ligne 24h/24 et 7j/7 ou par téléphone.",
  },
];

export const FeatureStrip = ({ brand }) => (
  <section className="feature-strip">
    <div className="container feature-strip-inner">
      {ITEMS.map((f) => (
        <div className="feature-item" key={f.title}>
          <span className="feature-icon">
            <Icon name={f.icon} size={24} />
          </span>
          <div>
            <h3>{f.title}</h3>
            <p>{f.text}</p>
          </div>
        </div>
      ))}

      <a className="feature-phone" href={`tel:${brand?.phoneLink || ""}`}>
        <span className="feature-phone-icon">
          <Phone size={18} />
        </span>
        <span className="feature-phone-text">
          <strong>{brand?.phone || ""}</strong>
          <em>{brand?.availabilityLong || brand?.availability || ""}</em>
        </span>
      </a>
    </div>
  </section>
);

export default FeatureStrip;
